import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as R from 'ramda';
import { push } from 'connected-react-router';
import { getMenuSettingsConfig } from '@constants/config';
import { verifyPermissions } from '@utils/permission-utils';
import './menu.scss';
import UnstyledHeading from '@components/shared/unstyled-heading';

const SETTINGS_MENU_HEADER_ID = 'settings-menu-header';

const Menu = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const onMenuClick = type => dispatch(push(`/settings/${type}`));

  const isActive = type => {
    const { pathname } = location;
    const nameSlice = R.slice(2, 3);
    const name = R.pipe(R.split('/'), nameSlice)(pathname)[0];
    return type === name;
  };

  const renderMenuItem = item => {
    const { label, permissions, type } = item;
    if (!verifyPermissions(permissions)) {
      return null;
    }
    const active = isActive(type);
    return (
      <div
        data-testid="settings-menu-item"
        key={type}
        onClick={() => onMenuClick(type)}
        role="presentation"
        styleName={`menu-item ${active ? 'active' : ''}`}
      >
        {label}
      </div>
    );
  };

  const items = getMenuSettingsConfig();
  return (
    <nav data-testid="settings-menu" styleName="menu-container" aria-labelledby={SETTINGS_MENU_HEADER_ID}>
      <UnstyledHeading rank={2} id={SETTINGS_MENU_HEADER_ID} ariaOnly>settings menu</UnstyledHeading>
      {items.map(item => renderMenuItem(item))}
    </nav>
  );
};

export default Menu;
